import React, { useEffect, useState } from "react";
import { UiComponents } from "@simulanisindia/ui";
import { saveSearchValue } from "../../store/slice/searchSlice";
import { SearchFilterIconMob, SearchIcon } from "../../Icons";
import { useDispatch, useSelector } from "react-redux";
import FilterOption from "../filteroption";

const SearchbarMobile = ({
  showFilterBtn = false,
  activeTab,
  selectedCheckboxes = [],
  handleResetCheckBox,
  handleSelectApplication,
}) => {
  const dispatch = useDispatch();
  const [showFilter, setShowFilter] = useState(false);
  const [search, setSearch] = useState("");

  const openFilter = () => {
    setShowFilter((prev) => (document.body.classList.toggle("filter-active"), !prev));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(saveSearchValue({ data: search }));
    }, 1000);

    return () => clearTimeout(timer);
  }, [search]);

  const resetCheckBox = () => {
    if (handleResetCheckBox) {
      handleResetCheckBox();
    }
  };

  const handleSelectItem = (e) => {
    if (handleSelectApplication) {
      handleSelectApplication(e);
    }
  };

  return (
    <>
      <div className={showFilter ? "searchMobile" : "searchMobile noFilter"}>
        <input type="text" placeholder="Search" value={search} onChange={(e) => setSearch(e.target.value)} />
        <span className="searchIcon">
          <SearchIcon />
        </span>

        {showFilterBtn && (
          <span className="filterIcon" onClick={openFilter}>
            <SearchFilterIconMob />
            {selectedCheckboxes.length > 0 && <span className="filter-active-span"></span> }
          </span>
        )}
      </div>

      <FilterOption
        showfilter={showFilter}
        selectedCheckboxes={selectedCheckboxes}
        activeTab={activeTab}
        handleResetCheckBox={resetCheckBox}
        onToggleFilter={openFilter}
        handleSelectCheckbox={(e) => handleSelectItem(e)}
      />
    </>
  );
};

export default SearchbarMobile;
